import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'uni-global-header',
    templateUrl: './university-header.component.html',
    styleUrls: ['./university-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class UniversityHeaderComponent implements OnInit {

    constructor(
    ) { }

    ngOnInit(): void {
    }

}
